<template>
  <v-layout class="px-3" column justify-center align-center fill-height style="height: 100svh">
    <div class="width-100">
      <v-img
        id="main-logo"
        width="60%"
        class="mx-auto"
        src="@/assets/logo/nice-basic.png"
        alt="nice logo"
      />
    </div>
    <div class="width-100">
      <v-form @submit.prevent="signin(user)">
        <v-text-field
          v-model="user.email"
          label="이메일"
          outlined
          dense
          style="margin-top: 20px"
          :error="!!invalidMsg.email"
          :rules="rules.email"
        ></v-text-field>
        <v-text-field
          type="password"
          v-model="user.password"
          label="비밀번호"
          outlined
          dense
          style="margin-top: 20px"
        ></v-text-field>
        <v-text-field
          type="password"
          v-model="user.rePassword"
          label="비밀번호 확인"
          outlined
          dense
          style="margin-top: 20px"
        ></v-text-field>
        <v-btn
          type="submit"
          class="width-100"
          color="primary"
          style="margin-top: 20px"
          :disabled="signinLoading || !isValidAll"
          :loading="signinLoading"
          >회원가입</v-btn
        >
      </v-form>
    </div>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getRedirectUriAndRemove } from '@/util'
import Regex from '@/const/Regex'

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
        rePassword: '',
      },
      signinLoading: false,
      invalidMsg: {
        email: null,
      },
      rules: {
        email: [
          (value) => !!value || '메일 주소를 입력해주세요.',
          (value) => Regex.EMAIL.REGEX.test(value) || Regex.EMAIL.MSG,
        ],
        password: [(value) => !!value || '패스워드를 입력해주세요'],
      },
      emailIsValid: false,
      passwordIsValid: false,
    }
  },
  created() {},
  computed: {
    isValidAll() {
      console.log(this.password?.length > 5)
      return this.emailIsValid && this.passwordIsValid
    },
    ...mapGetters('myfinbiz', ['isDefaultPlatform']),
  },
  watch: {
    'user.email'(email) {
      this.emailValidate(email)
    },
    'user.password'(password) {
      this.passwordIsValid = password.length > 5
    },
  },
  methods: {
    ...mapMutations('status', ['refresh']),
    ...mapActions('auth', ['signinIdPassword']),
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    emailValidate(email) {
      const msg = this.getFormErrMsg('email', email)
      if (msg === null) {
        this.emailIsValid = true
      } else {
        this.emailIsValid = false
      }
    },
    async movePage() {
      let redirectUri = getRedirectUriAndRemove()
      if (!redirectUri) {
        redirectUri = '/'
      }

      await this.$router.replace(redirectUri)
    },
    async signin(user) {
      try {
        this.signinLoading = true
        await this.signinIdPassword(user)
        await this.movePage()
      } catch (e) {
        if (e.status === 400) {
          this.user.password = ''
        }
        throw e
      } finally {
        this.signinLoading = false
      }
    },
    async signinSuccess() {
      this.refresh()
      await this.movePage()
    },
  },
}
</script>
